import React from 'react';

// Shared header/footer chrome for pages that must be reachable and readable
// without signing in (Google OAuth branding verification requires this):
// the marketing home page plus /about, /privacy, /terms.
export default function PublicPageShell({ title, updated, children }) {
  return (
    <div className="public-page">
      <header className="public-page__header">
        <a href="/" className="public-page__brand">
          <img src="/grove-symbol.png" alt="" className="public-page__brand-icon" />
          <span>
            Grove <span className="public-page__brand-sub">— Family Ops Hub</span>
          </span>
        </a>
        <nav className="public-page__nav">
          <a href="/about">About</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </nav>
      </header>
      <main className="public-page__body">
        <h1 className="public-page__title">{title}</h1>
        {updated && <p className="public-page__updated">Last updated {updated}</p>}
        <div className="public-page__content">{children}</div>
      </main>
      <footer className="public-page__footer">
        <span>Grove — calm family logistics, simplified.</span>
      </footer>
    </div>
  );
}
